/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react';
import ImageBasic from '../common/ImageBasic';
import { Image as ImageType } from '../../typings';
import { isPortrait } from '../../utilities/browser';

interface InlineGalleryItemProps {
  image: ImageType;
  handleClick: Function;
}

const InlineGalleryItem = ({
  image,
  handleClick,
}: InlineGalleryItemProps) => (
  <div
    role="button"
    className={`inline-gallery__item ${isPortrait(image) && 'inline-gallery__item--portrait'}`}
    onClick={() => handleClick()}
    tabIndex={0}
    data-width={image.file?.details?.image.width}
  >
    <ImageBasic image={image} />
  </div>
);
export default InlineGalleryItem;
